var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLPinkLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 132,
    viewBox: "0 0 89 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1462 0.427778C37.1842 0.461821 38.8205 2.24793 38.8772 4.47659C39.254 19.41 40.2208 71.6655 40.5635 87.2457C40.6157 89.6491 42.3995 91.5623 44.5964 91.5805C47.5944 91.6031 51.8293 91.5782 55.5445 91.5305C63.8804 91.3785 75.9837 90.9836 84.3446 90.8406C86.5551 90.802 88.3889 92.6766 88.4819 95.0914C88.7724 102.712 88.8927 118.495 88.9336 125.823C88.9449 127.988 87.379 129.758 85.3999 129.808C81.653 129.899 75.4073 130.051 68.9278 130.21C50.8194 130.652 24.745 131.272 6.53898 131.712C4.50323 131.762 2.79428 130.078 2.64677 127.854C1.39173 108.758 0.465764 26.4908 0.120798 5.7702C0.079947 3.26693 1.88193 1.20169 4.1696 1.11545C11.6726 0.834027 27.4434 0.298416 35.1439 0.427778H35.1462Z",
    fill: "#DA716A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLPinkLetter);
export default __webpack_public_path__ + "static/media/l-pink-letter.8bdb0d14e39a29d6d209a9c6e8aec7b7.svg";
export { ForwardRef as ReactComponent };